import type { SVGProps } from 'react';

const Shuffle = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1667 3.83331L12.8333 5.33331L11.1667 6.83331"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1667 9.16669L12.8333 10.6667L11.1667 12.1667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.16667 10.8333C8 10.8333 5.33333 5.33331 12.6667 5.33331"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 9.67709C9.3672 10.2699 10.6713 10.6667 12.6667 10.6667M3.16667 5.16669C3.16667 5.16669 4.67708 5.32294 5.48959 5.89585"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Shuffle;
